/* @ts-self-types="./index.d.ts" */
export {litPlugin, litPlugin as default} from './lib/plugin.js';
export type {LitPluginOptions} from './lib/plugin.js';
export type {
  ElementInfo,
  EditorConfig,
  SourceOverlayOptions,
} from './lib/types.js';
